export default '/pricing/tier-mobile';
